import { getApiContentEncryption, getCallbackUrl } from 'src/clients';
import { getRedirectUrl } from 'src/clients/BusinessPayment/Channel/redirectUrl';
import { ACTION_TYPES } from './types';

export const loadApiContentEncryption = () => {
  return {
    types: [
      ACTION_TYPES.DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION,
      ACTION_TYPES.DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION_SUCCESS,
      ACTION_TYPES.DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION_FAILED,
    ],
    client: () => getApiContentEncryption(),
  };
};

export const loadCallbackUrl = () => {
  return {
    types: [
      ACTION_TYPES.DEVELOPER_OPTION_GET_CALLBACK_URL,
      ACTION_TYPES.DEVELOPER_OPTION_GET_CALLBACK_URL_SUCCESS,
      ACTION_TYPES.DEVELOPER_OPTION_GET_CALLBACK_URL_FAILED,
    ],
    client: () => getCallbackUrl(),
  };
};

export const loadRedirectUrl = () => {
  return {
    types: [
      ACTION_TYPES.DEVELOPER_OPTION_GET_REDIRECT_URL,
      ACTION_TYPES.DEVELOPER_OPTION_GET_REDIRECT_URL_SUCCESS,
      ACTION_TYPES.DEVELOPER_OPTION_GET_REDIRECT_URL_FAILED,
    ],
    client: () => getRedirectUrl(),
  };
};
